import React, { useState, useEffect } from 'react'
import { Switch, Route, Redirect, withRouter, useHistory, useLocation } from 'react-router-dom'
import { useAuth } from 'bxl-auth'
import Dashboard from 'bxl-dashboard'
import NotFound from '@pages/notfound'
import SizeChartList from '@pages/sizeChartList'
import SizeChartEditor from '@pages/sizeChartEditorPage'
import DiscoveryPage from './pages/discovery'
import ImageSearch from './pages/imageSearch'
import SearchDebuggerPage from './pages/searchDebugger'
import QueryAnalyzerPage from './pages/queryAnalyzer'
import ProductDetail from './pages/productDetail'
import BuildTag from './containers/BuildTag'
import PatchCategory from './containers/PatchCategory'
import CategoryTreeContainer from './containers/CategoryTreeContainer'
import RecordedBrandsList from './containers/RecordedBrandsList'
import MerchantBrandsList from './containers/MerchantBrandsList'
import BatchBrandModification from './containers/BatchBrandModification'
import CategoryChange from './containers/CategoryChange'
import CNName from './containers/CNName'
import SimilarProducts from './components/SimilarProducts'
import Checkout from './containers/Checkout'
import FrontCategory from './containers/FrontCategory'
import Boosts from './components/Boosts'
import AttributeItemList from '@pages/attributes/attributeList'
import CategoryAttributeList from '@pages/attributes/categoryAttributeList'
import ProductAttributeEdit from '@pages/attributes/productAttributeEdit'
import UploadProductAttributes from '@pages/attributes/uploadProductAttributes'
import { getUserInfoDetail } from './services/loginService'
import './App.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchMerchants } from './actions/MerchantsCreators';
import { fetchBrands } from './actions/BrandsCreators';
import { fetchCategoryTree } from './actions/CategoryCreators';
import {
  CURATORS_ROLE,
  UPDATE_BRAND,
  VIEW_CATEGORY_MENU,
  UPDATE_INVENTORY,
  UPDATE_SIZE_CHARTS,
  UPDATE_TARGETED_PRICE,
  BATCH_PRODUCT_INFOR,
} from './common/constants'
import PriceComparison from './pages/priceComparison'
import bxlUtils from 'bxl-utils'
import StandardProduct from './pages/standardProduct'
import Crawler from './containers/Crawler'
function PrivateRoute({ component: Children, ...rest }) {
    const { user } = useAuth()
    if(!!user) {
        return <Route component={Children} {...rest}  />
    } else {
        return <Redirect
            {...rest}
            to={{
                pathname: '/login',
                search: rest?.location?.search,
                state: { path: rest?.location?.pathname },
            }}
        />
    }
}

function Login() {
    const history = useHistory()
    const location = useLocation<{ path: string }>()
    const { signIn } = useAuth()
    useEffect(() => {
        signIn && signIn().then(user => {
            if (user?.sessionKey) {
            history.replace({
                pathname: location.state?.path || '/',
                search: location.search,
            })
            }
      })
    })
    return null
}

const defaultRoute = [{
    id: 'discover',
    name: 'Discover',
    icon: 'GlobalOutlined'
  }, {
    id: 'product-list',
    pid: 'discover',
    route: '/discover',
    name: 'Product Search',
    icon: 'SearchOutlined'
  }, {
    id: 'image-search',
    name: 'Image Search',
    pid: 'discover',
    icon: 'ScanOutlined',
    route: '/image-search'
  }, {
    id: 'search-debugger',
    name: 'Search Debugger',
    pid: 'discover',
    icon: 'BugOutlined',
    route: '/search-debugger',
  }, {
    id: 'query-analyzer',
    name: 'Query Test',
    pid: 'discover',
    icon: 'CoffeeOutlined',
    route: '/query-analyzer',
  }, {
    id: 'category',
    name: '分类管理',
    icon: 'ProfileOutlined',
  }, {
    id: 'categoryTree',
    pid: 'category',
    route: '/category-tree',
    name: 'Category Tree',
    icon: 'ApartmentOutlined'
  }, {
    id: 'frontCategory',
    pid: 'category',
    route: '/front-category',
    name: '前台类目',
    icon: 'LayoutOutlined'
  }, {
    id: 'attribute',
    name: '属性管理',
    icon: 'BookOutlined'
  }, {
    id: 'attribute-items',
    pid: 'attribute',
    route: '/attribute-items',
    name: '属性池',
    icon: 'DatabaseOutlined'
  }, {
    id: 'category-attribute',
    pid: 'attribute',
    route: '/category-attribute',
    name: '分类属性映射',
    icon: 'BranchesOutlined',
  }, {
    id: 'product-attribute',
    pid: 'attribute',
    route: '/product-attribute',
    name: '商品属性编辑',
    icon: 'ClusterOutlined',
  }, {
    id: 'upload-attributes',
    pid: 'attribute',
    route: '/upload-attributes',
    name: '批量导入商品属性',
    icon: 'UploadOutlined',
  }, {
    id: 'product-tool',
    name: '商品工具',
    icon: 'ToolOutlined',
  }, {
    id: 'tagging',
    pid: 'product-tool',
    route: '/tagging',
    name: 'Tagging',
    icon: 'TagsOutlined',
  }, {
    id: 'boosts',
    pid: 'product-tool',
    route: '/boosts',
    name: 'Boosts',
    icon: 'RiseOutlined'
  }, {
    id: 'crawler',
    pid: 'product-tool',
    route: '/crawler',
    name: '爬商品',
    icon: 'SearchOutlined'
  }, {
    id: 'checkout-mock',
    name: 'Checkout Mock',
    pid: 'product-tool',
    icon: 'DollarOutlined',
    route: '/checkout'
  }, {
    id: 'standard-product',
    name: '一品多商',
    pid: 'product-tool',
    icon: 'ApartmentOutlined',
    route: '/standard-product',
  }]

function checkRole(role, menu) {
  const roleList = JSON.parse(sessionStorage.getItem(CURATORS_ROLE) || '[]')
  if(roleList.indexOf(role) >= 0) {
    return menu
  }
  return []
}

const App: React.FC = (props: any) => {
  const { signOut, user } = useAuth()
  const {
    fetchMerchants,
    fetchBrands,
    fetchCategoryTree
  } = props
  const [routeList, setRouteList] = useState(defaultRoute)

  useEffect(() => {
    fetchMerchants()
    fetchBrands()
    fetchCategoryTree()
  }, [])

  useEffect(() => {
    const userId = user?.userId || ''
    getUserInfoDetail(userId).then(res => {
        const role = res.data?.role?.capabilities;
        if(role) {
          sessionStorage.setItem(CURATORS_ROLE, JSON.stringify(role));
          const appendedRoutes = [
            ...checkRole(VIEW_CATEGORY_MENU, [
              {
                id: 'categoryChange',
                pid: 'category',
                route: '/category-change',
                name: '批量修改分类',
                icon: 'BorderOuterOutlined',
              },
            ]),
            ...checkRole(UPDATE_BRAND, [
              {
                id: 'brands',
                name: '品牌管理',
                icon: 'BoldOutlined',
              },
              {
                id: 'recorded-brands',
                pid: 'brands',
                route: '/recorded-brands-list',
                name: '管理品牌列表',
                icon: 'SwapOutlined',
              },
              {
                id: 'merchant-brands',
                pid: 'brands',
                route: '/merchant-brands-list',
                name: '商家品牌列表',
                icon: 'SwapLeftOutlined',
              },
            ]),
            ...checkRole(BATCH_PRODUCT_INFOR, [
              {
                id: 'batchBrandsModification',
                pid: 'brands',
                route: '/batch-brand-modification',
                name: '批量修改品牌',
                icon: 'SplitCellsOutlined',
              },
            ]),
            ...checkRole(UPDATE_INVENTORY, [
              {
                id: 'cnName',
                pid: 'product-tool',
                route: '/cn-name',
                name: '批量修改商品中文名',
                icon: 'FontSizeOutlined',
              },
            ]),
            ...checkRole(UPDATE_SIZE_CHARTS, [
              {
                id: 'sizeCharts',
                route: '/size-charts',
                name: '尺码表管理',
                icon: 'ScissorOutlined',
              },
            ]),
            ...checkRole(UPDATE_TARGETED_PRICE, [
              {
                id: 'priceComparison',
                route: '/price-comparison',
                name: '比价',
                icon: 'CalculatorOutlined',
              },
            ]),
          ]
          setRouteList([...defaultRoute, ...appendedRoutes])
        }
    })
  }, [user])

  return (
    <div className="App">
      <Dashboard
        isMobile={bxlUtils.platform.isAndroid() || bxlUtils.platform.isIOS()}
        onSignOut={() => {
          signOut().then(() => {
            window.location.replace('#/login')
          })
        }}
        username={user?.userName || 'Unknown'}
        name='Curators'
        avatar='https://baleen-cdn-g.bybieyang.com/static/images/admin/default_avatar.png'
        routeList={routeList}>
          <Switch>
            <PrivateRoute exact path='/discover' component={DiscoveryPage} />
            <PrivateRoute exact path='/image-search/:id?' component={ImageSearch} />
            <PrivateRoute exact path="/discover/:id" component={ProductDetail} />
            <PrivateRoute exact path="/discover/similar/:id" component={SimilarProducts} />
            <PrivateRoute exact path="/checkout/:id?" component={Checkout} />
            <PrivateRoute path="/tagging" component={BuildTag} />
            <PrivateRoute path="/boosts" component={Boosts} />
            <PrivateRoute path="/patchcategory/:id" component={PatchCategory} />
            <PrivateRoute path="/recorded-brands-list" component={RecordedBrandsList} />
            <PrivateRoute path="/merchant-brands-list" component={MerchantBrandsList} />
            <PrivateRoute path="/batch-brand-modification" component={BatchBrandModification} />
            <PrivateRoute path="/category-tree" component={CategoryTreeContainer} />
            <PrivateRoute path="/category-change" component={CategoryChange} />
            <PrivateRoute path="/front-category" component={FrontCategory} />
            <PrivateRoute path="/cn-name" component={CNName} />
            <PrivateRoute path="/size-charts" component={SizeChartList} />
            <PrivateRoute path="/size-chart-editor/:id?" component={SizeChartEditor} />
            <PrivateRoute path="/attribute-items" component={AttributeItemList} />
            <PrivateRoute path="/category-attribute" component={CategoryAttributeList} />
            <PrivateRoute path="/product-attribute/:id?" component={ProductAttributeEdit} />
            <PrivateRoute path="/upload-attributes" component={UploadProductAttributes} />
            <PrivateRoute path="/price-comparison" component={PriceComparison} />
            <PrivateRoute path="/standard-product" component={StandardProduct} />
            <PrivateRoute path="/crawler" component={Crawler} />
            <PrivateRoute path="/search-debugger" component={SearchDebuggerPage} />
            <PrivateRoute path="/query-analyzer" component={QueryAnalyzerPage} />
            <Route exact path="/login" component={Login} />
            <Route path='/404' component={NotFound} />
            <Redirect from="/" to='/discover' />
            <Redirect from='*' to='/404' />
          </Switch>
      </Dashboard>
    </div>
  );
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ fetchMerchants, fetchBrands, fetchCategoryTree }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
